import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import useAlert from '../../hooks/useAlert';
import { TypedDocumentNode, useMutation, useQuery } from '@apollo/client';
import {
  getUserById,
  getUserRoles,
  MIXPANEL_EVENTS,
  ProcureUser,
  updateUserRole as updateUserRoleMutation,
  UserRole,
} from 'vendor-marketplace-shared-library';
import { UPDATE_USER_ROLE } from '../../error-messages';
import useMixpanel from '../../hooks/useMixpanel';

type UserRoleSelectorProps = {
  user: ProcureUser;
  onChange?: () => void;
};

export default function UserRoleSelector(props: UserRoleSelectorProps) {
  const { setAlert } = useAlert();
  const { mixpanelTrack } = useMixpanel();
  const userRolesQuery = useQuery(getUserRoles);
  const [updateUserRole] = useMutation(updateUserRoleMutation as TypedDocumentNode, {
    refetchQueries: [getUserRoles, getUserById],
    onError: () => {
      setAlert({ severity: 'error', message: UPDATE_USER_ROLE });
    },
    onCompleted: () => {
      mixpanelTrack(MIXPANEL_EVENTS.ORGANIZATION_SETTINGS_USER_ROLE_FILTER_PRESSED);
    },
  });

  const userRoles = userRolesQuery.data?.getUserRoles ?? [];

  const onUpdateUserRole = async (userRoleId: string) => {
    await updateUserRole({
      variables: { id: props.user.id, input: { userRoleId: Number(userRoleId) } },
    });
    if (props.onChange) props.onChange();
  };

  return (
    <FormControl fullWidth>
      <InputLabel>User Role</InputLabel>
      <Select
        value={props.user.userRole?.id || ''}
        label='User Role'
        onChange={e => onUpdateUserRole(e.target.value)}
      >
        {userRoles.map((userRole: UserRole) => (
          <MenuItem key={userRole.id} value={userRole.id}>
            {userRole.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
